import React from 'react'
import styles from './style.module.scss'
import { useState, FC, CSSProperties } from 'react'
import classNames from 'classnames'

export { MonthBoxCellIdPrefix } from './constants'
import { MonthBoxCellIdPrefix } from './constants'

interface MonthBoxCellProps {
  date: Date
  isFocused: boolean
  isCurrentMonth?: boolean
  onCellClick: (date: Date) => void
  onCellDoubleClick: (date: Date) => void
  weekCount: number
}

const MonthBoxCell: FC<MonthBoxCellProps> = ({
  date,
  isFocused,
  isCurrentMonth = false,
  onCellClick,
  onCellDoubleClick,
  weekCount,
}) => {
  const day = date.getDate()
  const month = date.getMonth() + 1
  const isToday =
    new Date().getDate() === day &&
    new Date().getMonth() === date.getMonth() &&
    new Date().getFullYear() === date.getFullYear()

  const [timeoutId, setTimeoutId] = useState<NodeJS.Timeout | null>(null)
  const handleClick = () => {
    if (!timeoutId) {
      onCellClick(date)
      const t = setTimeout(() => {
        setTimeoutId(null)
      }, 250)
      setTimeoutId(t)
    }
  }

  const handleDoubleClick = () => {
    timeoutId && clearTimeout(timeoutId)
    setTimeoutId(null)
    const currentDate = new Date()
    let sendDate = new Date(date)
    sendDate.setHours(currentDate.getHours())
    sendDate.setMinutes(currentDate.getMinutes())
    sendDate.setSeconds(0)
    sendDate.setMilliseconds(0)
    onCellDoubleClick(sendDate)
  }

  return (
    <div
      id={MonthBoxCellIdPrefix + month + '_' + day}
      className={classNames(
        styles.monthBoxCell,
        isCurrentMonth ? styles.currentMonth : styles.otherMonth,
        isFocused ? styles.focused : '',
        isToday ? styles.today : '',
      )}
      style={{ '--var-week-count': weekCount } as CSSProperties}
      onClick={handleClick}
      onDoubleClick={handleDoubleClick}
    >
      <div className={styles.dayNumber}>{day}</div>
    </div>
  )
}

export default MonthBoxCell
